var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"board-tile",class:!_vm.tile.value ? 'blank' : 'board-tile',on:{"click":function($event){_vm.getTileCoordinates()}}},[_vm._v("\n\n    "+_vm._s(_vm.showTileValue)+"\n    \n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12baba54","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tile.vue
// module id = 23
// module chunks = 0